import { isArray } from 'lodash-es'

import axios from '@util/axios'

export const LincolnBDXService = {
  checkPendingStatus: (role, role_value, options = {}) =>
    axios({
      ...options,
      url: '/lincoln/bdx-status-pending/check/',
      method: 'POST',
      data: {
        role,
        role_value
      }
    }),
  export: (role, role_value, email, params = {}, options = {}) => {
    const query = Object.entries(params)
      .filter(([_, value]) => !!value)
      .map(([key, value]) => {
        if (!isArray(value)) return `${key}=${value}`

        return value.map((v) => `${key}=${v}`).join('&')
      })
      .join('&')

    return axios({
      ...options,
      url: `/lincoln/bdx-export/?${query}`,
      params: {
        role,
        role_value,
        email
      }
    })
  }
}
